import React from 'react';

import type { ExtensionComponentProps } from '@atlaskit/editor-common/extensions';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { usePageContentId } from '@confluence/page-context';

import { NBMRenderer } from './NBMRenderer.tsx';
import type { LegacyContentMacroParams } from './LegacyContentMacroParams.ts';

export const LegacyContentExtensionHandler = (
	props: ExtensionComponentProps<LegacyContentMacroParams>,
) => {
	const [contentId] = usePageContentId();

	return (
		<ErrorBoundary
			attribution={Attribution.CC_EDITOR_AI}
			attributes={{ contentId, nodeLocalId: props.node?.localId }}
		>
			<NBMRenderer node={props.node} />
		</ErrorBoundary>
	);
};
